// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input--dynamic[data-v-f5e6b28c] {\n  width: 55%;\n}", ""]);
// Exports
module.exports = exports;
